@if (data?.isPopUp) {
  <div class="daily-frise-container" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
    <div class="sticky-header">
      <div class="lastUpdateDate">
        @if (lastUpdateDate != null) {
          {{ ' Derniere mise à jour le ' + (lastUpdateDate | date: 'EEEE dd MMMM HH:mm' : '' : 'fr' | titlecase) }}
        }
      </div>
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div class="padding-inline" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
          <h1 class="current-date">
            {{ fullDays[selectedDayIndex!] | date: 'EEEE d MMMM yyyy' : 'UTC' | titlecase }}
          </h1>
          @if (nbDays > 1) {
            <mat-icon (click)="prev()" class="chevron" [class.disabled]="selectedDayIndex === 0">chevron_left</mat-icon>
            <mat-icon (click)="next()" class="chevron" [class.disabled]="selectedDayIndex === 6"
              >chevron_right</mat-icon
            >
          }
        </div>
        <div (click)="close()" class="close-btn" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="0.5rem">
          <mat-icon>close</mat-icon>
          <span>Fermer</span>
        </div>
      </div>

      <div class="tab" *ngIf="tempFormations && tempFormations.length <= 5">
        @if (tempFormations.length > 1) {
          <div
            class="tab"
            [class.selected]="
              selectedFormation === null || (selectedFormation.name === 'All' && selectedFormation._id === '0')
            "
            (click)="onChangeSelectedFormation({ name: 'All', _id: '0' })"
          >
            Tous
          </div>
        }

        <div
          *ngFor="let formation of tempFormations"
          class="tab"
          [class.selected]="selectedFormation?.name === formation.name"
          (click)="onChangeSelectedFormation(formation)"
        >
          {{ formation.name }}
        </div>
      </div>

      <div class="default-select" *ngIf="tempFormations && tempFormations.length > 5">
        <div class="select-container">
          <select
            [(ngModel)]="selectedFormation"
            (ngModelChange)="onChangeSelectedFormation($event)"
            [ngModelOptions]="{ standalone: true }"
          >
            <option [ngValue]="{ name: 'All', _id: '0' }">Tous</option>
            <option *ngFor="let formation of tempFormations" [ngValue]="formation">
              {{ formation.name }}
            </option>
          </select>
        </div>
      </div>
    </div>

    @if (!isDataLoading) {
      <div class="column-container" fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="0.5rem">
        <div class="column padding-20" fxFlex="50" fxLayout="column" fxLayoutGap="1rem">
          <div fxLayout="row" fxLayoutAlign="space-between center" class="column-header">
            <span>Bilan effectif / besoins</span>
            <span
              class="effective-need"
              [class.positive]="dayEffectifs[selectedDayIndex!] - dayNeeds[selectedDayIndex!] >= 0"
              [class.negative]="dayEffectifs[selectedDayIndex!] - dayNeeds[selectedDayIndex!] < 0"
              >{{ dayEffectifs[selectedDayIndex!] || 0 }}/{{ dayNeeds[selectedDayIndex!] || 0 }}</span
            >
          </div>
          @if (selectedReasonMaps && selectedReasonMaps.length > 0) {
            @for (reasonMap of selectedReasonMaps; track $index; let index = $index) {
              <div
                fxLayout="row"
                fxLayoutAlign="space-between center"
                class="badge-container"
                [matTooltip]="
                  inactiveDaysMap[index][selectedDayIndex!] ? 'Ce code horaire est inactif pour ce jour' : ''
                "
              >
                <app-code-rh-badge
                  [text]="reasonMap.code || ''"
                  [reasonMap]="reasonMap"
                  [color]="reasonMap.color || '#FFFFFF'"
                  [startTime]="
                    (reasonMap.morningStartTime | date: 'HH:mm' : 'UTC') ||
                    (reasonMap.nightStartTime | date: 'HH:mm' : 'UTC') ||
                    ''
                  "
                  [endTime]="
                    (reasonMap.afternoonEndTime | date: 'HH:mm' : 'UTC') ||
                    (reasonMap.nightEndTime | date: 'HH:mm' : 'UTC') ||
                    ''
                  "
                  textSize="10"
                ></app-code-rh-badge>
                <span
                  class="effective-need"
                  [class.positive]="(reasonMap.diff?.[selectedDayIndex!] ?? 0) >= 0"
                  [class.negative]="(reasonMap.diff?.[selectedDayIndex!] ?? 0) < 0"
                  >{{ reasonMap.effectifs?.[selectedDayIndex!] ?? 0 }}/{{
                    reasonMap.needs?.[selectedDayIndex!]?.need ?? 0
                  }}</span
                >
              </div>
            }
          }
        </div>

        @if (showDailyFrise) {
          <div class="column" fxFlex="50">
            <table class="width-100 hourly-table">
              <thead>
                <tr>
                  <th style="width: 32px"></th>
                  <th>
                    <div class="day-cell-header" fxLayout="column" fxLayoutAlign="center center">
                      <p class="name-day">{{ fullDays[selectedDayIndex!] | date: 'EEEE' : 'UTC' | titlecase }}</p>
                      <p class="date-display-row text-style-1">
                        {{ fullDays[selectedDayIndex!] | date: 'd MMM' : 'UTC' }}
                      </p>
                      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="3px">
                        @if (scheduleDataAfter && scheduleDataAfter.length > 0) {
                          <p class="day-needs percentage-badge" fxLayout="row" fxLayoutAlign="center center">
                            {{ scheduleData[selectedDayIndex!].percentage }}%
                          </p>
                          <mat-icon>arrow_right_alt</mat-icon>
                          <p
                            class="day-needs percentage-badge"
                            [ngClass]="'percentage-' + scheduleDataAfter[selectedDayIndex!].percentageLabel"
                            fxLayout="row"
                            fxLayoutAlign="center center"
                          >
                            {{ scheduleDataAfter[selectedDayIndex!].percentage }}%
                          </p>
                        } @else {
                          <p
                            class="day-needs percentage-badge"
                            [ngClass]="'percentage-' + scheduleData[selectedDayIndex!].percentageLabel"
                            fxLayout="row"
                            fxLayoutAlign="center center"
                          >
                            {{ scheduleData[selectedDayIndex!].percentage }}%
                          </p>
                        }
                      </div>

                      <div class="bar-need-indicator" style="position: relative">
                        <span class="bar-need-indicator-red" style="position: absolute; left: 11%"
                          >3
                          <span style="top: -5px; position: absolute">-</span>
                        </span>
                        <span class="bar-need-indicator-red" style="position: absolute; left: 24%">2</span>
                        <span class="bar-need-indicator-red" style="position: absolute; left: 37%">1</span>
                        <span class="bar-need-indicator-green" style="position: absolute; left: 63%">1</span>
                        <span class="bar-need-indicator-green" style="position: absolute; left: 76%">2</span>
                        <span class="bar-need-indicator-green" style="position: absolute; left: 89%"
                          >3
                          <span style="top: -5px; position: absolute">+</span>
                        </span>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (hour of dayHours; track $index; let index = $index) {
                  <tr>
                    <td fxLayout="row" fxLayoutAlign="center center" class="hour-label">
                      <span class="hour">{{ hour.hour }}</span>
                      <span class="half-hour">{{ hour.halfHour }}</span>
                    </td>
                    <td class="schedule-cell">
                      @if (index === 0) {
                        <div
                          class="schedule-cell-content"
                          [style.height]="'calc((40px * ' + numberOfRows + ') + (2px * ' + numberOfBorders + '))'"
                        >
                          <div class="center-reference-line"></div>

                          <!-- scheduleData[selectedDayIndex!].bars -->
                          @for (bar of getBarsForDay2(selectedDayIndex); track $index) {
                            <div
                              class="bar-container"
                              [style.top.%]="bar.topPercent"
                              [style.height.%]="bar.heightPercent"
                            >
                              <div
                                class="bar-fill"
                                [ngClass]="'fill-' + bar.color"
                                [style.left.%]="bar.fillLeftPercent"
                                [style.width.%]="bar.fillWidthPercent"
                              ></div>

                              <div class="schedule-bar" [ngClass]="'bar-' + bar.color" [style.left.%]="bar.leftPercent">
                                <span class="bar-value-tooltip" [ngClass]="'tooltip-' + bar.color">{{
                                  bar.value > 0 ? '+' + bar.value : bar.value
                                }}</span>
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    } @else {
      <div class="spinner-wrapper" fxLayout="row" fxLayoutAlign="center center" *ngIf="isDataLoading">
        <mat-spinner></mat-spinner>
      </div>
    }
  </div>
} @else if (!data?.isPopUp && !isFriseOnly) {
  <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
    <div class="date-header" fxLayout="row" fxLayoutAlign="space-between center">
      <div class="date-picker-container" fxLayout="row" fxLayoutAlign="start center">
        <app-toggle-switch
          *ngIf="isNight !== undefined && showDayNight"
          [isDayNight]="true"
          class="margin-right"
          style="height: fit-content; margin-right: 12px"
          [options]="dayNightOptions"
          [actifOption]="isNight"
          (onOptionClick)="toggleNight()"
        ></app-toggle-switch>
        <app-custom-date-picker-week
          class="with-arrows"
          (dateSwitch)="onWeekChange($event)"
          (weekPicked)="chosenDayHandler($event)"
          [day]="$any(day)"
        ></app-custom-date-picker-week>
        <div fxLayout="column" *ngIf="populationList && populationList.length > 0">
          <div class="w-200">
            <div class="default-select">
              <div class="select-container">
                <select [formControl]="currentPopulation" (change)="onPopulationSelected()" placeholder="Tous">
                  <option value="none">Aucun périmètre</option>
                  <option *ngFor="let population of populationList" [value]="population._id">
                    {{ population.name }} ({{ population.formationsNames }})
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="default-select" *ngIf="tempFormations && tempFormations.length > 6">
          <div class="select-container">
            <select
              [(ngModel)]="selectedFormation"
              (ngModelChange)="onChangeSelectedFormation($event)"
              [ngModelOptions]="{ standalone: true }"
            >
              <option *ngFor="let formation of tempFormations" [ngValue]="formation">
                {{ formation.name }}
              </option>
            </select>
          </div>
        </div>
        <div fxLayoutGap="30px" fxLayout="row" fxLayoutAlign="start center">
          <div class="margin-left-15px" fxLayout="row" fxLayoutAlign="start center">
            <mat-slide-toggle
              (click)="toggleShowReasonMapsFromAdjustmentAlgo()"
              [checked]="showReasonMapsFromAdjustmentAlgo"
            >
            </mat-slide-toggle>
            <span class="margin-left-6px">Afficher les codes horaires de récupération</span>
          </div>
          <div class="margin-left-15px" fxLayout="row" fxLayoutAlign="start center">
            <mat-slide-toggle (click)="toggleShowFrise()" [checked]="showFrise"> </mat-slide-toggle>
            <span class="margin-left-6px">Afficher la frise hebdomadaire</span>
          </div>
        </div>
      </div>
      <div class="message">{{ lastUpdateMessage }}</div>
    </div>

    <div class="tab" *ngIf="tempFormations && tempFormations.length <= 5">
      @if (tempFormations.length > 1) {
        <div
          class="tab"
          [class.selected]="
            selectedFormation === null || (selectedFormation.name === 'All' && selectedFormation._id === '0')
          "
          (click)="onChangeSelectedFormation({ name: 'All', _id: '0' })"
        >
          Tous
        </div>
      }

      <div
        *ngFor="let formation of tempFormations"
        class="tab"
        [class.selected]="selectedFormation?.name === formation.name"
        (click)="onChangeSelectedFormation(formation)"
      >
        {{ formation.name }}
      </div>
    </div>

    <div
      *ngIf="!isDataLoading && selectedReasonMaps && selectedReasonMaps.length > 0"
      fxLayout="row"
      fxLayoutAlign="space-between center"
      fxLayoutGap="12px"
    >
      <div
        class="consultations-container2"
        [class.fullWidth]="!showFrise"
        fxLayout="column"
        fxLayoutAlign="start start"
      >
        <table class="width-100">
          <thead>
            <tr>
              <th class="tab-header-container">
                <div class="tab-header">
                  <span class="code-rh-title">Codes horaire</span>
                  <div class="diagonal-line"></div>
                  <span class="needs-title">Bilan</span>
                </div>
              </th>
              <th *ngFor="let day of days; let i = index">
                <div class="day-cell-header m-w-72" fxLayout="column" fxLayoutAlign="center center">
                  <p class="name-day">{{ day }}</p>
                  <p class="date-display-row text-style-1">{{ weekDays[i] }}</p>
                  <p class="day-needs" fxLayout="row" fxLayoutAlign="center center">{{ dayNeeds[i] }}</p>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let reasonMap of selectedReasonMaps; let index = index">
              <td fxLayout="row" fxLayoutAlign="center center" class="p-t-18">
                <div class="code-rh-container">
                  <app-code-rh-badge
                    [text]="reasonMap.code || ''"
                    [reasonMap]="reasonMap"
                    [color]="reasonMap.color || '#FFFFFF'"
                    [startTime]="
                      (reasonMap.morningStartTime | date: 'HH:mm' : 'UTC') ||
                      (reasonMap.nightStartTime | date: 'HH:mm' : 'UTC') ||
                      ''
                    "
                    [endTime]="
                      (reasonMap.afternoonEndTime | date: 'HH:mm' : 'UTC') ||
                      (reasonMap.nightEndTime | date: 'HH:mm' : 'UTC') ||
                      ''
                    "
                    textSize="10"
                  ></app-code-rh-badge>
                </div>
              </td>
              <td *ngFor="let day of days; let i = index">
                <ng-container *ngIf="reasonMap.needs[i]">
                  <div
                    fxLayout="row"
                    class="reason-info-container"
                    [matTooltip]="inactiveDaysMap[index][i] ? 'Ce code horaire est inactif pour ce jour' : ''"
                  >
                    <input
                      [ngClass]="{
                        'c-pointer': accessOption?.permissionWrite && !inactiveDaysMap[index][i],
                        'green-background': reasonMap?.needs[i].need > 0 && (reasonMap?.diff?.[i] ?? 0) >= 0,
                        'red-background': (reasonMap?.diff?.[i] ?? 0) < 0,
                      }"
                      (keydown)="blockInvalidInput($event, index, i)"
                      (ngModelChange)="updateDiff($event, index, i)"
                      type="number"
                      [disabled]="!accessOption?.permissionWrite || inactiveDaysMap[index][i]"
                      [(ngModel)]="reasonMap.needs[i].need"
                      (input)="reasonMap.needs[i].need = validateNeed(i, reasonMap.needs, indexTable, index)"
                      [min]="0"
                      [max]="999"
                      [maxlength]="3"
                      placeholder="00"
                      (blur)="setDefaultIfEmpty(reasonMap.needs[i].need, index, i)"
                      (paste)="preventPaste($event)"
                      (keydown.control.v)="preventPaste($event)"
                      (keydown.meta.v)="preventPaste($event)"
                    />
                    <div *ngIf="accessOption?.permissionWrite" class="select-arrows" fxLayout="column">
                      <button
                        class="custom-icon-button"
                        [disabled]="inactiveDaysMap[index][i] || reasonMap.needs[i].need >= 999"
                        mat-icon-button
                        (click)="reasonMap.needs[i].need = increaseNeeds(i, reasonMap.needs, indexTable, index)"
                      >
                        <mat-icon>keyboard_arrow_up</mat-icon>
                      </button>
                      <div class="tick"></div>
                      <button
                        class="custom-icon-button"
                        [disabled]="inactiveDaysMap[index][i] || reasonMap.needs[i].need === 0"
                        mat-icon-button
                        matSuffix
                        (click)="reasonMap.needs[i].need = decreaseNeeds(i, reasonMap.needs, indexTable, index)"
                      >
                        <mat-icon>keyboard_arrow_down</mat-icon>
                      </button>
                    </div>
                    <div fxFlexAlign="center">
                      <span
                        class="font-weight-700 day-diff"
                        [class.green-text]="(reasonMap?.diff?.[i] ?? 0) >= 0"
                        [class.red-text]="(reasonMap?.diff?.[i] ?? 0) < 0"
                        >{{
                          ((reasonMap?.diff?.[i] ?? 0) >= 0 ? '+' : '') + formatNumber(reasonMap?.diff?.[i] ?? 0)
                        }}</span
                      >
                    </div>
                  </div>
                </ng-container>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Frise Hebdo -->
      @if (showFrise) {
        <div
          class="consultations-container2"
          style="padding: 0 16px"
          fxLayout="column"
          fxLayoutAlign="start start"
          fxFlex="50%"
        >
          <table class="width-100 hourly-table">
            <thead>
              <tr>
                <th style="width: 32px"></th>
                <th *ngFor="let day of days; let i = index">
                  <div class="day-cell-header" fxLayout="column" fxLayoutAlign="center center">
                    <p class="name-day">{{ day }}</p>
                    <p class="date-display-row text-style-1">{{ weekDays[i] }}</p>
                    <!-- Updated to show percentage badge with color coding -->
                    <p
                      class="day-needs percentage-badge"
                      [ngClass]="'percentage-' + scheduleData[i].percentageLabel"
                      fxLayout="row"
                      fxLayoutAlign="center center"
                    >
                      {{ scheduleData[i].percentage }}%
                    </p>
                    <!-- Updated diff indicator layout -->
                    <div fxLayout="row" fxLayoutAlign="center center" class="bar-need-indicator" fxLayoutGap="13px">
                      <span class="bar-need-indicator-red" style="position: relative"
                        >3
                        <span style="top: -5px; position: absolute">-</span>
                      </span>
                      <span class="bar-need-indicator-red">2</span>
                      <span class="bar-need-indicator-red">1</span>
                      <span class="bar-need-indicator-green">1</span>
                      <span class="bar-need-indicator-green">2</span>
                      <span class="bar-need-indicator-green" style="position: relative"
                        >3
                        <span style="top: -5px; position: absolute">+</span>
                      </span>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (hour of dayHours; track $index; let index = $index) {
                <tr>
                  <td fxLayout="row" fxLayoutAlign="center center" class="hour-label">
                    <span class="hour">{{ hour.hour }}</span>
                    <span class="half-hour">{{ hour.halfHour }}</span>
                  </td>
                  <!-- Add schedule bars to each day cell -->
                  @for (dayData of scheduleData; track $index; let dayIndex = $index) {
                    <td class="schedule-cell">
                      @if (index === 0) {
                        <div
                          class="schedule-cell-content"
                          [style.height]="'calc((40px * ' + numberOfRows + ') + (2px * ' + numberOfBorders + '))'"
                        >
                          <!-- Center reference line (dashed vertical line at 0) -->
                          <div class="center-reference-line"></div>

                          <!-- Render bars spanning the entire day -->
                          @for (bar of dayData.bars; track $index) {
                            <div
                              class="bar-container"
                              [style.top.%]="bar.topPercent"
                              [style.height.%]="bar.heightPercent"
                            >
                              <!-- Fill area between center and bar -->
                              <div
                                class="bar-fill"
                                [ngClass]="'fill-' + bar.color"
                                [style.left.%]="bar.fillLeftPercent"
                                [style.width.%]="bar.fillWidthPercent"
                              ></div>

                              <!-- Actual bar with hover tooltip -->
                              <div class="schedule-bar" [ngClass]="'bar-' + bar.color" [style.left.%]="bar.leftPercent">
                                <span class="bar-value-tooltip" [ngClass]="'tooltip-' + bar.color">{{
                                  bar.value > 0 ? '+' + bar.value : bar.value
                                }}</span>
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>

    <div class="spinner-wrapper" fxLayout="row" fxLayoutAlign="center center" *ngIf="isDataLoading">
      <mat-spinner></mat-spinner>
    </div>
  </div>
} @else if (!data?.isPopUp && isFriseOnly) {
  <!-- Full width frise view after adjustment algorithm -->
  <div class="tab" *ngIf="tempFormations && tempFormations.length <= 5">
    @if (tempFormations.length > 1) {
      <div
        class="tab"
        [class.selected]="
          selectedFormation === null || (selectedFormation.name === 'All' && selectedFormation._id === '0')
        "
        (click)="onChangeSelectedFormation({ name: 'All', _id: '0' })"
      >
        Tous
      </div>
    }

    <div
      *ngFor="let formation of tempFormations"
      class="tab"
      [class.selected]="selectedFormation?.name === formation.name"
      (click)="onChangeSelectedFormation(formation)"
    >
      {{ formation.name }}
    </div>
  </div>

  <div class="default-select" *ngIf="tempFormations && tempFormations.length > 5">
    <div class="select-container">
      <select
        [(ngModel)]="selectedFormation"
        (ngModelChange)="onChangeSelectedFormation($event)"
        [ngModelOptions]="{ standalone: true }"
      >
        <option [ngValue]="{ name: 'All', _id: '0' }">Tous</option>
        <option *ngFor="let formation of tempFormations" [ngValue]="formation">
          {{ formation.name }}
        </option>
      </select>
    </div>
  </div>

  <div fxLayout="column" fxLayoutAlign="center" fxLayoutGap="20px">
    @if (!isDataLoading && scheduleDataAfterAdjustment.length > 0) {
      <div class="consultations-container" fxLayout="column" fxLayoutAlign="start start">
        <table class="width-100 hourly-table">
          <thead>
            <tr>
              <th style="width: 32px"></th>
              <th *ngFor="let day of days; let i = index">
                <div class="day-cell-header" fxLayout="column" fxLayoutAlign="center center">
                  <p class="name-day">{{ day }}</p>
                  <p class="date-display-row text-style-1">{{ weekDays[i] }}</p>
                  <!-- (mouseenter)="onMouseEnter(i)"
                  (mouseleave)="onMouseLeave(i)" Updated to show percentage badge with color coding (!isBeforAfterOnMouseEnterToggled || isDayHovered[i]) &&-->
                  @if (scheduleDataAfterAdjustment && scheduleDataAfterAdjustment.length > 0) {
                    <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="0.5rem">
                      <p class="day-needs percentage-badge" fxLayout="row" fxLayoutAlign="center center">
                        {{ scheduleData[i].percentage }}%
                      </p>
                      <mat-icon>arrow_right_alt</mat-icon>
                      <p
                        class="day-needs percentage-badge"
                        [ngClass]="'percentage-' + scheduleDataAfterAdjustment[i].percentageLabel"
                        fxLayout="row"
                        fxLayoutAlign="center center"
                      >
                        {{ scheduleDataAfterAdjustment[i].percentage }}%
                      </p>
                    </div>
                  }
                  <!-- @else if (scheduleDataAfterAdjustment && scheduleDataAfterAdjustment.length > 0) {
                    <p
                      class="day-needs percentage-badge"
                      [ngClass]="'percentage-' + scheduleDataAfterAdjustment[i].percentageLabel"
                      fxLayout="row"
                      fxLayoutAlign="center center"
                    >
                      {{ scheduleDataAfterAdjustment[i].percentage }}%
                    </p>
                  } -->

                  <!-- Updated diff indicator layout -->
                  <div fxLayoutAlign="center center" class="bar-need-indicator" style="position: relative">
                    <span class="bar-need-indicator-red" style="position: absolute; left: 11%"
                      >3
                      <span style="top: -5px; position: absolute">-</span>
                    </span>
                    <span class="bar-need-indicator-red" style="position: absolute; left: 24%">2</span>
                    <span class="bar-need-indicator-red" style="position: absolute; left: 37%">1</span>
                    <span class="bar-need-indicator-green" style="position: absolute; left: 63%">1</span>
                    <span class="bar-need-indicator-green" style="position: absolute; left: 76%">2</span>
                    <span class="bar-need-indicator-green" style="position: absolute; left: 89%"
                      >3
                      <span style="top: -5px; position: absolute">+</span>
                    </span>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (hour of dayHours; track $index; let index = $index) {
              <tr>
                <td fxLayout="row" fxLayoutAlign="center center" class="hour-label">
                  <span class="hour">{{ hour.hour }}</span>
                  <span class="half-hour">{{ hour.halfHour }}</span>
                </td>
                <!-- Add schedule bars to each day cell (mouseenter)="onMouseEnter(dayIndex)"
                        (mouseleave)="onMouseLeave(dayIndex)" -->
                @for (dayData of scheduleDataAfterAdjustment; track $index; let dayIndex = $index) {
                  <td class="schedule-cell">
                    @if (index === 0) {
                      <div
                        class="schedule-cell-content"
                        [style.height]="'calc((40px * ' + numberOfRows + ') + (2px * ' + numberOfBorders + '))'"
                      >
                        <!-- Center reference line (dashed vertical line at 0) -->
                        <div class="center-reference-line"></div>

                        <!-- Render bars spanning the entire day -->
                        @for (bar of getBarsForDay(dayIndex, dayData); track $index) {
                          <div
                            class="bar-container"
                            [style.top.%]="bar.topPercent"
                            [style.height.%]="bar.heightPercent"
                          >
                            <!-- Fill area between center and bar -->
                            <div
                              class="bar-fill"
                              [ngClass]="'fill-' + bar.color"
                              [style.left.%]="bar.fillLeftPercent"
                              [style.width.%]="bar.fillWidthPercent"
                            ></div>

                            <!-- Actual bar with hover tooltip -->
                            <div class="schedule-bar" [ngClass]="'bar-' + bar.color" [style.left.%]="bar.leftPercent">
                              <span class="bar-value-tooltip" [ngClass]="'tooltip-' + bar.color">{{
                                bar.value > 0 ? '+' + bar.value : bar.value
                              }}</span>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    } @else {
      <div
        class="spinner-wrapper"
        fxLayout="row"
        fxLayoutAlign="center center"
        *ngIf="isDataLoading || scheduleDataAfterAdjustment.length === 0"
      >
        <mat-spinner></mat-spinner>
      </div>
    }
  </div>
}
